const brokers = [
  "MetaTrader 4",
  "MetaTrader 5",
  "cTrader",
  "Pepperstone",
  "Eightcap",
  "FOREX.com",
];

export const TrustBar = () => {
  return (
    <section className="container mx-auto px-4 sm:px-6 lg:px-8 mt-12">
      <div className="rounded-xl bg-card/60 ring-1 ring-border/40 px-6 py-5">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-4 lg:gap-8">
          <p className="text-[11px] font-bold tracking-widest text-muted-foreground uppercase shrink-0">
            Trusted by traders using
          </p>
          <div className="flex flex-wrap items-center gap-x-8 gap-y-3 lg:gap-x-10">
            {brokers.map((b) => (
              <span
                key={b}
                className="text-sm font-semibold text-foreground hover:text-foreground transition-colors"
              >
                {b}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
